export const NOTIFICATION_CHANNEL = {
  WHATSAPP: 'whatsapp',
  EMAIL: 'email',
} as const;

export type NotificationChannel =
  typeof NOTIFICATION_CHANNEL.WHATSAPP |
  typeof NOTIFICATION_CHANNEL.EMAIL;

export const NOTIFICATION_CHANNEL_LABEL = {
  [NOTIFICATION_CHANNEL.WHATSAPP]: 'WhatsApp',
  [NOTIFICATION_CHANNEL.EMAIL]: 'Email',
} as const;

export const NOTIFICATION_DIALOG_TITLE = {
  WHATSAPP: '📱 Send WhatsApp',
  EMAIL: '✉️ Send Email',
} as const;

export const NOTIFICATION_BUTTON_LABEL = {
  WHATSAPP: 'WhatsApp',
  EMAIL: '📧 Email',
  SENDING: 'Sending…',
  CONFIRM_SEND: 'Confirm & Send',
} as const;

export const NOTIFICATION_TOAST = {
  WHATSAPP_SENT: 'WhatsApp message sent!',
  WHATSAPP_FAILED: 'Failed to send WhatsApp message.',
  EMAIL_SENT: 'Confirmation email sent successfully!',
  EMAIL_FAILED: 'Failed to send email.',
} as const;

export const DETAIL_MESSAGE = {
  BOOKING_NOT_FOUND: 'Booking not found',
} as const;

export const AUDIT_ACTION = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  AMOUNT_OVERRIDE: 'AMOUNT_OVERRIDE',
  WHATSAPP_SENT: 'WHATSAPP_SENT',
  EMAIL_SENT: 'EMAIL_SENT',
} as const;

export const AUDIT_DISPLAY = {
  WHATSAPP_SENT_LABEL: '📱 WhatsApp Sent',
  EMAIL_SENT_LABEL: '✉️ Email Sent',
  AMOUNT_OVERRIDE_LABEL: 'Amount Override',
} as const;
